import ChartProcess from "./Growth/ChartProcess";
import ChartMomentum from "./Momentum/ChartMomentum";
import Efficiency from "./Momentum/Efficiency";

import './Momentum.scss'
import useMomentum from "hook/useMomentum";
import { useSelector } from "react-redux";

export default function Momentum() {
  const MomentumStore = useSelector((state: any) => state?.MomentumStore)
  const AStore = useSelector((state: any) => state?.AStore)
  const { compareDataOverview } = useMomentum()
  const dataOverview = compareDataOverview(AStore?.Overview, MomentumStore?.OverviewMomentum)

  const marketCap = dataOverview?.marcap_value?.[0];
  const marketCapIcb = dataOverview?.marcap_value?.[1];
  const data = [
    {
      title: 'Đà tăng',
      chartStart: { value: dataOverview?.uptrend?.[0], color: '#F7931A', valueShow: dataOverview?.uptrend_value?.[0] },
      chartEnd: { value: dataOverview?.uptrend?.[1], color: '#F7931A', valueShow: dataOverview?.uptrend_value?.[1] }
    },
    {
      title: 'Thanh khoản',
      chartStart: { value: dataOverview?.liquidity?.[0], color: '#F7931A', valueShow: dataOverview?.liquidity_value?.[0] },
      chartEnd: { value: dataOverview?.liquidity?.[1], color: '#F7931A', valueShow: dataOverview?.liquidity_value?.[1] }
    },
    {
      title: 'Điểm mua',
      chartStart: { value: dataOverview?.buyPoint?.[0], color: '#F7931A', valueShow: dataOverview?.buyPoint_value?.[0] },
      chartEnd: { value: dataOverview?.buyPoint?.[1], color: '#F7931A', valueShow: dataOverview?.buyPoint_value?.[1] }
    },
    {
      title: 'Vốn hoá',
      chartStart: { value: dataOverview?.marcap?.[0], color: '#F7931A', valueShow: marketCap },
      chartEnd: { value: dataOverview?.marcap?.[1], color: '#F7931A', valueShow: marketCapIcb }
    },
  ]

  return (
    <>
      <div className="HLYnZJLysX">
        <div className="SRwtmoyscR">
          <ChartMomentum />
        </div>
      </div>
      <div className="pnqncnqdtk">
        <div className="cowxcfbbbs">
          <ChartProcess data={data} title="Đánh giá ngành" />
        </div>
        <div className="mxjthmhxxt">
          <Efficiency title={"Hiệu suất giá cổ phiếu"} marginBottom={'24px'} />
        </div>
      </div>
    </>
  )
}